module.exports = __webpack_public_path__ + "3e330e0e6b9988fbe10a41bb40c5172a.png";